import { Component } from "@angular/core";
import { BrowseSubjectsComponent } from "../../../shared/business/browse-subjects/browse-subjects.component";
import { StaticStudyToolsComponent } from "../../../shared/business/static-study-tools/static-study-tools.component";
import { CoverStaticExamComponent } from "../../../shared/UI/cover-static-exam/cover-static-exam.component";
import { WhyLoveExamComponent } from "../../../shared/UI/why-love-exam/why-love-exam.component";
import { StaticCardExamComponent } from "../../../shared/business/static-card-exam/static-card-exam.component";
import { ExploreToolsComponent } from "../../../shared/UI/explore-tools/explore-tools.component";

@Component({
  selector: "app-static-exam-question",
  imports: [
    // BrowseSubjectsComponent,
    // StaticStudyToolsComponent,
    CoverStaticExamComponent,
    WhyLoveExamComponent,
    StaticCardExamComponent,
    ExploreToolsComponent,
  ],
  templateUrl: "./static-exam-question.component.html",
  styleUrl: "./static-exam-question.component.css",
})
export class StaticExamQuestionComponent {}
